import { useStyles } from "../../components";
import { CardContainer } from "../../components";

export default function TextExamples() {
  const { gStyle } = useStyles();
  return (
    <CardContainer>
      <h2 style={{ ...gStyle.title, ...gStyle.bold }}>
        Header h2 스타일 with gStyle.title + gStyle.bold
      </h2>
      <h2 style={{ ...gStyle.title, ...gStyle.highLight }}>
        Header h2 스타일 with gStyle.title + gStyle.highLight
      </h2>

      <p style={{ ...gStyle.subtitle }}>
        문장 텍스트 p 스타일 with gStyle.subtitle</p>
      <p style={{ ...gStyle.subtitle, ...gStyle.bold }}>
        문장 텍스트 p 스타일 with gStyle.subtitle gStyle.bold</p>
      
      <p style={{ ...gStyle.text }}>
        문장 텍스트 p 스타일 with gStyle.text</p>
      <p style={{ ...gStyle.text, ...gStyle.bold }}>
        문장 텍스트 p 스타일 with gStyle.text gStyle.bold</p>

      <p>문장 텍스트 p 스타일</p>
      <p style={{ ...gStyle.bold }}>문장 텍스트 p 스타일 with gStyle.bold</p>

      <h1>Header H1 스타일</h1>
      <h1 style={{ ...gStyle.bold }}>Header H1 스타일 with gStyle.bold</h1>
      <h1 style={{ ...gStyle.highLight }}>Header H1 스타일 gStyle.hightLight</h1>
      <h1 style={{ ...gStyle.title, ...gStyle.bold }}>Header H1 스타일 with gStyle.title | gStyle.bold</h1>
      <br />

      <h2>Header H2 스타일</h2>
      <h2 style={{ ...gStyle.bold }}>Header H2 스타일 with gStyle.bold</h2>
      <h2 style={{ ...gStyle.title, ...gStyle.bold }}>Header H2 스타일 with gStyle.title | gStyle.bold</h2>
      <h2 style={{ ...gStyle.title, ...gStyle.highLight }}>Header H2 스타일 with gStyle.title | gStyle.hightLight</h2>
      <br />

      <h3>Header H3 스타일</h3>
      <h3 style={{ ...gStyle.bold }}>Header H3 스타일 with gStyle.bold</h3>
      <br />

      <h4>Header H4 스타일</h4>
      <h4 style={{ ...gStyle.bold }}>Header H4 스타일 with gStyle.bold</h4>
      <br />

      <h5>Header H5 스타일</h5>
      <h5 style={{ ...gStyle.bold }}>Header H5 스타일 with gStyle.bold</h5>
      <br />
    </CardContainer>
  )
}